// extracted by mini-css-extract-plugin
export default {"value":"TPEfaZ6ilCuhU90Ftgbw"};